// Copy for the shared barcode label print panel (CatalogBarcodePrintModal).
// Display text only — the printed label content is produced by
// catalogBarcodePrint.js and is not affected by these strings.

const tx = (sq, en) => ({ sq, en });

const labelPrintTranslations = {
  title: tx("Printo etiketat me barkod", "Print barcode labels"),
  description: tx(
    "Printo etiketat për variantet e zgjedhura. Çdo etiketë përdor barkodin real të variantit.",
    "Print labels for the selected sellable variants. Each label uses the real catalog variant barcode."
  ),
  empty: tx("Nuk u gjet asnjë variant për printim.", "No printable variants found."),
  loading: tx("Duke ngarkuar variantet për printim…", "Loading printable variants…"),
  close: tx("Mbyll", "Close"),
  cancel: tx("Anulo", "Cancel"),
  print: tx("Printo etiketat", "Print labels"),
  variantsSelected: tx("Variante të zgjedhura", "Variants selected"),
  totalLabels: tx("Etiketa gjithsej", "Total labels"),
  pages: tx("Faqe", "Pages"),
  selectAll: tx("Zgjidh të gjitha", "Select all"),
  clear: tx("Pastro", "Clear"),
  colPick: tx("Zgjidh", "Pick"),
  colVariant: tx("Varianti", "Variant"),
  colBarcode: tx("Barkodi", "Barcode"),
  colAdded: tx("Shtuar", "Added"),
  colCopies: tx("Kopje", "Copies"),
  colLabel: tx("Etiketa", "Label"),
  stock: tx("Stoku: {count}", "Stock: {count}"),

  quantityTitle: tx("Sasia e etiketave", "Quantity mode"),
  quantityCopy: tx(
    "Zgjidh nëse fillon me një etiketë për variant apo sipas stokut në dyqan.",
    "Choose whether labels start at one per variant or follow the stock on hand."
  ),
  labelsPerPageSummary: tx(
    "A4 • {columns} × {rows} • {count} etiketa/faqe",
    "A4 • {columns} × {rows} • {count} labels/page"
  ),
  totalLabelsSummary: tx("Etiketa gjithsej: {count}", "Total labels: {count}"),
  pagesSummary: tx("Faqe: {count}", "Pages: {count}"),
  modeOnePerVariant: tx("Një për variant", "One per variant"),
  modeOnePerVariantHelp: tx(
    "Printon një etiketë për secilin variant të zgjedhur.",
    "Prints one label for each selected variant."
  ),
  modeMatchStock: tx("Sipas stokut në dyqan", "Match stock on hand"),
  modeMatchStockHelp: tx(
    "Një etiketë për çdo copë fizike në dyqan, përfshirë copat e rezervuara për porosi.",
    "One label per physical item in the store, including items reserved for orders."
  ),
  recalculate: tx("Rillogarit kopjet", "Recalculate copies"),

  calibrationTitle: tx("Kalibrimi i printimit", "Print calibration"),
  calibrationCopy: tx(
    "Cilësimet e faqes A4 ruhen në këtë shfletues dhe zbatohen menjëherë në parapamje dhe printim.",
    "A4 layout controls saved in this browser and applied live to preview and print."
  ),
  calibrationSummary: tx("A4 • {columns} × {rows} • {count} etiketa", "A4 • {columns} × {rows} • {count} labels"),
  labelSize: tx("Madhësia e përafërt e etiketës {width} × {height}", "Approx. label size {width} × {height}"),
  presetDensity: tx("Dendësi maksimale", "Maximum density"),
  presetDensityHelp: tx(
    "Margjinat më të vogla të sigurta dhe hapësira më e ngushtë.",
    "Smallest safe margins with the tightest printer-safe spacing."
  ),
  presetCompact: tx("Kompakt", "Compact"),
  presetCompactHelp: tx(
    "Faqe më e dendur, me pak më shumë hapësirë.",
    "Denser sheet rhythm while keeping a little more breathing room."
  ),
  presetBalanced: tx("I balancuar", "Balanced"),
  presetBalancedHelp: tx(
    "Cilësimi i rekomanduar për printim të besueshëm në zyrë.",
    "The current recommended default for reliable office printing."
  ),
  presetSpacious: tx("I gjerë", "Spacious"),
  presetSpaciousHelp: tx(
    "Më shumë hapësirë rreth çdo etikete.",
    "More breathing room around each label for softer page density."
  ),
  sectionLayout: tx("Rrjeti", "Layout"),
  sectionLayoutCopy: tx(
    "Sa etiketa dalin horizontalisht dhe vertikalisht në faqen A4.",
    "Adjust how many labels appear across and down the A4 page."
  ),
  columns: tx("Kolona", "Columns"),
  columnsHelp: tx("Etiketa horizontalisht.", "Labels across the page."),
  columnsTitle: tx(
    "Ndryshimi i kolonave rillogarit gjerësinë e etiketës në faqen A4.",
    "Changing columns recalculates label width across the fixed A4 sheet."
  ),
  rows: tx("Rreshta", "Rows"),
  rowsHelp: tx("Etiketa vertikalisht.", "Labels down the page."),
  rowsTitle: tx(
    "Ndryshimi i rreshtave rillogarit lartësinë e etiketës në faqen A4.",
    "Changing rows recalculates label height down the fixed A4 sheet."
  ),
  sectionSpacing: tx("Hapësirat", "Spacing"),
  sectionSpacingCopy: tx(
    "Margjinat e sigurta të faqes dhe hapësira mes etiketave.",
    "Control page-safe padding and the rhythm between labels."
  ),
  gapX: tx("Hapësira X", "Gap X"),
  gapXHelp: tx("Hapësira horizontale mes etiketave.", "Horizontal space between labels."),
  gapXTitle: tx(
    "Hapësira mes kolonave përdoret në llogaritjen e rrjetit në milimetra.",
    "Column gap is used in the deterministic millimeter grid calculation."
  ),
  gapY: tx("Hapësira Y", "Gap Y"),
  gapYHelp: tx("Hapësira vertikale mes etiketave.", "Vertical space between labels."),
  gapYTitle: tx(
    "Hapësira mes rreshtave përdoret në llogaritjen e rrjetit në milimetra.",
    "Row gap is used in the deterministic millimeter grid calculation."
  ),
  padX: tx("Margjina X", "Safe pad X"),
  padXHelp: tx("Margjina e sigurt majtas dhe djathtas.", "Printer-safe left and right page margin."),
  padXTitle: tx(
    "Printerët kanë nevojë për margjinë sepse shumica nuk printojnë deri në skaj.",
    "Real printers need internal safety padding because most cannot print edge to edge."
  ),
  padY: tx("Margjina Y", "Safe pad Y"),
  padYHelp: tx("Margjina e sigurt lart dhe poshtë.", "Printer-safe top and bottom page margin."),
  padYTitle: tx(
    "Margjina më e vogël vertikale jep më shumë hapësirë, por ul tolerancën e printimit.",
    "Reducing vertical safe padding increases usable height but lowers print tolerance."
  ),
  sectionAlignment: tx("Drejtimi", "Alignment"),
  sectionAlignmentCopy: tx(
    "Korrigjo zhvendosjen e printerit pa ndryshuar rrjetin apo numrin e etiketave.",
    "Fine-tune printer drift without changing the grid or label count."
  ),
  offsetX: tx("Zhvendosja X", "Offset X"),
  offsetXHelp: tx("Lëviz gjithë faqen majtas ose djathtas.", "Shift the whole sheet left or right."),
  offsetXTitle: tx(
    "Përdor një zhvendosje të vogël nëse printeri printon pak majtas ose djathtas.",
    "Use a small horizontal offset if your printer drifts left or right."
  ),
  offsetY: tx("Zhvendosja Y", "Offset Y"),
  offsetYHelp: tx("Lëviz gjithë faqen lart ose poshtë.", "Shift the whole sheet up or down."),
  offsetYTitle: tx(
    "Përdor një zhvendosje të vogël nëse printimi del shumë lart ose poshtë.",
    "Use a small vertical offset if physical prints ride too high or low."
  ),
  sectionActions: tx("Veprime", "Actions"),
  sectionActionsCopy: tx(
    "Rikthe vetëm drejtimin ose të gjitha cilësimet e rekomanduara.",
    "Reset only alignment drift or restore the full recommended default setup."
  ),
  resetAlignment: tx("Rikthe drejtimin", "Reset alignment"),
  restoreDefaults: tx("Rikthe cilësimet fillestare", "Restore defaults"),
  decrease: tx("Zvogëlo: {label}", "Decrease {label}"),
  increase: tx("Rrit: {label}", "Increase {label}"),

  sheetTitle: tx("Parapamja e faqes A4", "A4 sheet preview"),
  sheetCopy: tx(
    "Parapamje e zvogëluar e faqes së parë me rrjetin aktual {columns} × {rows}.",
    "Scaled preview of the first printed sheet using the current {columns} × {rows} layout."
  ),
  sheetMoreOne: tx("+{count} etiketë në faqet në vijim", "+{count} label on following pages"),
  sheetMoreMany: tx("+{count} etiketa në faqet në vijim", "+{count} labels on following pages"),

  failuresTitle: tx("Printimi është bllokuar", "Printing is blocked"),
  blockedTitle: tx("{count} artikuj nuk mund të printohen", "{count} items can't be printed"),
  blockedMissingBarcode: tx(
    "Pa barkod — shto barkodin te produkti.",
    "No barcode — add one on the product."
  ),
  blockedSerializedNeedsUnit: tx(
    "Produkt i serializuar — printohen vetëm etiketat e copave, sepse barkodi i variantit nuk pranohet në arkë.",
    "Serialized product — only unit labels can be printed, because the variant barcode is rejected at the till."
  ),
  blockedUnrenderable: tx(
    "Barkodi “{barcode}” përmban shenja që nuk mund të printohen si CODE128.",
    "Barcode “{barcode}” has characters CODE128 cannot encode."
  ),
  densityTitle: tx("Disa barkode mund të mos lexohen", "Some barcodes may not scan"),
  densityReason: tx(
    "“{barcode}” printohet me vija {width} mm — provo ta skanosh para se të printosh shumë.",
    "“{barcode}” prints with {width} mm bars — test-scan one before printing many."
  ),
};

export default labelPrintTranslations;
